<ng-container *ngIf="importFieldsForm">
  <div class="header">
    <div class="title">Import Custom Fields</div>
    <button class="close-button" mat-icon-button (click)="closeModal()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
  <form [formGroup]="importFieldsForm" *ngIf="errors.length <= 0; else messagesPanel">
    <mat-form-field class="w-full treo-mat-no-subscript">
      <mat-label>Object Type</mat-label>
      <mat-select formControlName="relatedToType">
        <mat-option [value]="type.id ? type.name.toLowerCase() : type.name" *ngFor="let type of types">{{
          type.label | relatedToTypeTitle: types
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <section class="w-full mt-5">
      <input
        #fileUpload
        type="file"
        hidden
        (change)="onImportFileChange($event)"
        [accept]="acceptedFileExtensions"
        required
      />
      <div class="flex items-center">
        <ts-button color="primary" (click)="fileUpload.click()">
          <mat-icon class="mr-1">attach_file</mat-icon>
          Upload file
        </ts-button>

        <span class="ml-2">{{ importFieldsForm.get('file').value?.name || 'No file uploaded yet.' }}</span>
      </div>

      <p class="text-sm mt-2">
        Accepted formats are <strong>{{ acceptedFileExtensions.join(', ') }}</strong
        >.
      </p>
    </section>

    <div class="actions">
      <div class="buttons">
        <button class="discard-button" mat-button type="button" (click)="closeModal()">
          <span>Cancel</span>
        </button>
        <button
          data-cy="save-custom-field"
          id="import-button"
          class="send-button"
          mat-flat-button
          type="submit"
          [color]="'primary'"
          [disabled]="importFieldsForm.invalid"
          DebounceClick
          (debounceClick)="save()"
        >
          <span *ngIf="!importFieldsForm.disabled">Save</span>
          <mat-progress-spinner
            *ngIf="importFieldsForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #messagesPanel>
  <div class="messages-error-panel">
    <div class="messages-error-panel__header">
      <span
        *ngIf="importedFields.length"
        class="messages-error-panel__title messages-error-panel__title--success w-100 w-full"
      >
        <mat-icon [svgIcon]="'check'"></mat-icon>
        Imported {{ importedFields.length }}
        {{
          importedFields.length
            | i18nPlural
              : {
                  '=0': '',
                  '=1': 'field',
                  other: 'fields'
                }
        }}
        with success.
      </span>

      <span class="messages-error-panel__title messages-error-panel__title--error">
        <mat-icon [svgIcon]="'error'"></mat-icon>
        We found {{ errors.length }}
        {{
          errors.length
            | i18nPlural
              : {
                  '=0': '',
                  '=1': 'error',
                  other: 'errors'
                }
        }}. See details below.</span
      >
    </div>
    <div class="content">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="lineNumber">
          <th mat-header-cell *matHeaderCellDef>Line number</th>
          <td mat-cell *matCellDef="let element">{{ element.lineNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>Error message</th>
          <td mat-cell *matCellDef="let element">{{ element.message }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div class="actions">
      <div class="buttons">
        <button class="discard-button" mat-button type="button" (click)="resetForm()">
          <span>Back to import form</span>
        </button>
        <button class="send-button" mat-flat-button [color]="'primary'" (click)="closeModal()">Finish</button>
      </div>
    </div>
  </div>
</ng-template>
